import { useState, useEffect } from 'react';
import AppLayout from '@/components/feature/AppLayout';
import { useAuth } from '@/context/AuthContext';

export default function SWActivityPage() {
  const { user } = useAuth();
  const [activities, setActivities] = useState<any[]>([]);
  const [submissionCount, setSubmissionCount] = useState(0);

  useEffect(() => {
    fetch(`https://guardiancloudcare.com/backend/api/get_activity.php?uid=${user?.uid}`)
    .then(async (res) => {

      const text = await res.text();

      console.log(text);

      return JSON.parse(text);

    })
    .then(data => {

      if (Array.isArray(data)) {
        setActivities(data);
      } else {
        setActivities([]);
      }

    })
    .catch(err => {
      console.error(err);
      setActivities([]);
    });

    fetch(`https://guardiancloudcare.com/backend/api/get_submission_count.php?uid=${user?.uid}`)
    .then(res => res.json())
    .then(data => {

      setSubmissionCount(data.count || 0);

    })
    .catch(err => {
      console.error(err);
      setSubmissionCount(0);
    });
  }, []);

  return (
    <AppLayout title="My Activity" breadcrumb={['Social Worker', 'My Activity']}>

      <div className="space-y-4">

        {/* INFO */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3">
          <i className="ri-information-line text-amber-600 mt-0.5" />
          <p className="text-sm text-amber-700">
            Your activity is automatically recorded and visible to your supervisor for accountability and performance monitoring.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-4">
          {[
            {
              label: 'Actions Today',
              value: activities.length,
              color: 'text-teal-600',
              bg: 'bg-teal-50'
            },
            {
              label: 'Field Activities',
              value: activities.filter(a => a.type === 'field').length,
              color: 'text-amber-600',
              bg: 'bg-amber-50'
            },
            {
              label: 'Submissions',
              value: submissionCount,
              color: 'text-gray-700',
              bg: 'bg-gray-50'
            },
          ].map((s) => (
            <div key={s.label} className={`${s.bg} rounded-xl border border-gray-100 p-4 text-center`}>
              <p className={`text-3xl font-bold ${s.color}`}>{s.value}</p>
              <p className="text-sm text-gray-500 mt-1">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
          <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
            <h3 className="font-semibold text-gray-800">My Activity Log</h3>
            <span className="text-xs text-gray-400">Visible to supervisor</span>
          </div>

          <div className="divide-y divide-gray-50">

            {activities.map((a, index) => {

              const iconMap: Record<string, string> = {
                create: 'ri-add-circle-line',
                field: 'ri-map-pin-user-line',
                document: 'ri-file-upload-line',
                submit: 'ri-send-plane-line',
                update: 'ri-edit-line'
              };

              const colorMap: Record<string, string> = {
                create: 'bg-teal-50 text-teal-600',
                field: 'bg-amber-50 text-amber-600',
                document: 'bg-gray-50 text-gray-600',
                submit: 'bg-green-50 text-green-600',
                update: 'bg-orange-50 text-orange-600'
              };

              return (
                <div key={index} className="px-5 py-4 flex items-center gap-4">

                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${colorMap[a.type] || 'bg-gray-50 text-gray-600'}`}>
                    <i className={`text-sm ${iconMap[a.type] || 'ri-checkbox-circle-line'}`} />
                  </div>

                  <div className="flex-1">
                    <p className="text-sm font-medium text-gray-800">
                      {a.action}
                    </p>

                    <p className="text-xs font-mono text-gray-400">
                      {a.caseNumber}
                    </p>
                  </div>

                  <span className="text-xs text-gray-400 whitespace-nowrap">
                    {a.timestamp}
                  </span>

                </div>
              );
            })}

            {activities.length === 0 && (
              <div className="text-center text-gray-400 py-10">
                No activity found
              </div>
            )}

          </div>
        </div>

      </div>
    </AppLayout>
  );
}